import enquiryApi from 'api/enquiryApi'
import {
  Enquiries,
  EnquirySaveRequest,
  EnquiryListResponse,
  EnquiryListRequest,
  UserEnquiry
} from './types'

const EnquiryApiSlice = enquiryApi.injectEndpoints({
  endpoints: (build) => ({
    createEnquiry: build.mutation<Enquiries, EnquirySaveRequest>({
      query: ({ enquiryDTO }) => {
        return {
          url: '/enquiries',
          method: 'POST',
          data: enquiryDTO,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      },
      invalidatesTags: ['enquiry']
    }),
    getAllEnquiries: build.query<EnquiryListResponse, EnquiryListRequest>({
      query: ({ filters, page }) => {
        const params: { [key: string]: any } = {
          size: page?.size ?? 10,
          page: page?.number ? page.number - 1 : 0
        }

        if (filters && filters.length > 0) {
          filters.forEach(({ fieldName, fieldValue }) => {
            if (
              fieldValue === null ||
              fieldValue === undefined ||
              fieldValue === '' ||
              fieldValue === 'all'
            ) {
              delete params[fieldName]
            } else {
              params[fieldName] = fieldValue
            }
          })
        }

        return {
          url: `/enquiries`,
          method: 'GET',
          params
        }
      },
      providesTags: ['enquiry']
    }),
    updateEnquiryApproval: build.mutation<
      EnquiryListResponse,
      { userEnquiry: UserEnquiry, id: number }
    >({
      query: ({ id, userEnquiry }) => ({
        url: `/enquiries/${id}`,
        method: 'PATCH',
        data: userEnquiry
      }),
      invalidatesTags: ['enquiry']
    })
  })
})

export const {
  useCreateEnquiryMutation,
  useGetAllEnquiriesQuery,
  useUpdateEnquiryApprovalMutation
} = EnquiryApiSlice
